import styled from 'styled-components';
import { Button, Input } from 'react-rainbow-components';

const StyledButton = styled(Button)`
    width: 100%;
    margin-top: 16px;
`;

const StyledInput = styled(Input)`
    margin-bottom: 12px;
`;

export { StyledInput, StyledButton };
